var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBookmarkFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3767 1.00106C14.3628 1.00037 14.3486 1 14.3342 1H3.66973C2.19632 1 1.00195 2.19437 1.00195 3.66778V16.3321C1.00195 16.9048 1.67652 17.2109 2.10752 16.8338L7.00146 12.5516L11.8954 16.8337C12.3264 17.2109 13.001 16.9048 13.001 16.3321V8.99934H16.334C16.7022 8.99934 17.0006 8.7009 17.0006 8.33274V3.66644C17.0006 2.20796 15.8297 1.02387 14.3767 1.00106ZM15.6674 7.66611H13.001V3.66644C13.001 2.93003 13.5978 2.3332 14.3342 2.3332C15.0706 2.3332 15.6674 2.93 15.6674 3.66644V7.66611Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookmarkFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookmark-filled.02b801ac.svg";
export { ForwardRef as ReactComponent };